<template>
  <b-form-group
    class="form-group-checkbox-group form-group-check-garden-help"
    :label="field_label"
    label-class="form-label-filter-garden-help text-left "
    :field_model="field_model"
  >
    <b-form-checkbox-group
      id="service_filter"
      v-model="_field_model"
      name="field_model"
      stacked
    >
      <b-form-checkbox
        v-for="option in options.slice(0, length)"
        :key="option.id"
        class="checkbox-filter mb-1"
        v-model="_field_model"
        name="field_model"
        :value="option.id"
        >{{ option.name }}</b-form-checkbox
      >
    </b-form-checkbox-group>
    <b-button
      v-if="options.length > length"
      variant="garden-help-secondary-link"
      class="btn-bumblebee btn-garden-help view-more-action"
      @click="clickViewMore"
      >+ View more</b-button
    >
    <b-button
      v-if="options.length > max_length && options.length == length"
      variant="garden-help-secondary-link"
      class="btn-bumblebee btn-garden-help view-more-action"
      @click="clickViewLess"
      >- View less</b-button
    >
  </b-form-group>
</template>

<script>
export default {
  name: "InputCheckboxFilter",
  components: {},
  props: ["field_label", "field_model", "options"],
  data() {
    return {
      length: 3,
      max_length: 3,
    };
  },
  mounted() {
    // console.log(this.field_label);
    // console.log(this.field_model);
    // console.log(this.options);
  },

  computed: {
    _field_model: {
      get() {
        return this.field_model;
      },
      set(value) {
        this.$emit("update:field_model", value);
      },
    },
    optionsLoaded() {
      return this.options.slice(0, this.length);
    },
  },
  methods: {
    clickViewMore() {
      this.length = this.options.length;
    },
    clickViewLess() {
      this.length = this.max_length;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/projects/garden_help/components/InputCheckboxFilter.vue